import React from 'react';
import { AuthProvider as LegacyAuthProvider } from './AuthContext';

interface AuthProviderSelectorProps {
  children: React.ReactNode;
}

/**
 * Auth provider wrapper
 * SSR support has been removed as it was never used
 */
export const AuthProviderSelector: React.FC<AuthProviderSelectorProps> = ({ children }) => {
  return <LegacyAuthProvider>{children}</LegacyAuthProvider>;
};